import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sign-up-simple',
  templateUrl: './sign-up-simple.component.html',
  styleUrls: ['./sign-up-simple.component.scss']
})
export class SignUpSimpleComponent implements OnInit {

  guid = '';
  // bookId = '';
  constructor(private router: Router, private toastrService: ToastrService,
    private appService: AppService,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe((res: any) => {
      this.guid = res.guid;

      // blunder management: redirect 93f26d12-2391-4b58-88a2-22d54bb78879 to more-info
      // if (this.guid === '93f26d12-2391-4b58-88a2-22d54bb78879') {
      //   this.router.navigate(['more-info']);
      //   return;
      // }
      // this.appService.validateQr(res.guid).subscribe((res: any) => {
      //   if (!res.valid) {
      //     this.toastrService.error(res.message, "Please Try With valid activation code");
      //     this.router.navigate(['home']);
      //   } else if (res.inUse) {
      //     this.toastrService.error("Account is Active For this Code", "Please Try With other activation code");
      //     this.router.navigate(['home']);
      //   }
      //   this.bookId = res.book_id;
      // });
    })
  }

  public otp: any = false;
  policy_number: string = '';
  email_Id: string = "";
  hasError: boolean = false;
  hasSError: boolean = false;
  ErrorMessage: string = "";
  resendLinkEmailID: string = "";
  loginForm: any;
  otpForm: any;

  isShowOtpPage: any;
  isShowSignup: any;
  hidePassword = true;
  hideConfirmPassword = true;
  minAge = 6;
  minAgeDate: Date = new Date(new Date().setFullYear(new Date().getFullYear() - this.minAge));
  ngOnInit() {
    this.loginForm = new FormGroup({
      password: new FormControl('', [Validators.required, Validators.minLength(8)]),
      "firstName": new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(15)]),
      "lastName": new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(15)]),
      "displayName": new FormControl(''),
      "email": new FormControl('', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]),
      "phone": new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]),
      "status": new FormControl('Pending'),
      "dob": new FormControl('', [Validators.required, this.validateMinAge]),
      "occupation": new FormControl('', [Validators.required]),
      "cPassword": new FormControl('', [Validators.required]),
      "guid": new FormControl('Common-User'),
      "book_id": new FormControl('0125c44c-dbaf-4ab5-adf9-f040592b968e'),
    }, { validators: this.passwordMatchValidator });
  }

  onlyNumber($event) {
    const e = <KeyboardEvent>$event;
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
     return false;
    }
    return true;  
  }

  validateMinAge(control: AbstractControl): { [key: string]: boolean } | null {
    const dob = new Date(control.value);
    const today = new Date();
    const age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    if (age < 6 || (age === 6 && monthDiff < 0)) {
      return { minAge: true };
    }
    return null;
  }

  passwordMatchValidator(group: AbstractControl): null {
    const pw = group.get('password');
    const confirm = group.get('cPassword');

    if (!pw || !confirm) return null;

    if (pw.value !== confirm.value) {
      // attach to the confirm control
      confirm.setErrors({ passwordMismatch: true });
    } else {
      // clear only that error, not others
      const errs = confirm.errors;
      if (errs) {
        delete errs['passwordMismatch'];
        confirm.setErrors(Object.keys(errs).length ? errs : null);
      }
    }

    // always return null because we manage the control’s errors directly
    return null;
  }
  ngAfterViewInit() {

  }

  onSubmit() {
    if (this.loginForm.valid) {
      let data = this.loginForm.value;
      this.appService.hashPassword(this.loginForm.value.password).then((res: any) => {
        data.password = res;
        delete data['cPassword'];
        data['dob'] = new Date(data['dob']).toISOString().substring(0, 10);
        if (data['dob'] == 'Invalid Date') {
          this.toastrService.error('Invalid Date', 'Please Provide Valid Date of Birth');
          return;
        }
        if (new Date(data['dob']).getTime() > new Date().getTime()) {
          this.toastrService.error('Invalid Date', 'Please Provide Valid Date of Birth');
          return;
        }
        data['displayName'] = data['firstName'] + ' ' + data['lastName'];
        this.appService.signUp(data).subscribe((res: any) => {

          this.appService.sendEmail({
            recipient_email: data.email,
            subject: 'Account Activation',
            message: `Hello <b>${data.displayName}</b>,<br/><br/>Please click the link below to activate your account:\n\n<a href="${environment.siteUrl}activate/${res.id}">Account Activation</a><br/><br/>
          Thank you!<br/>P. Sharani Team<br/>`
          }).subscribe((res: any) => {
            this.toastrService.success('Please check your email for activation link', 'User Details are Saved and Activation Link Sent to your Email ID');
            this.router.navigate(["/login"]);
          }, (err) => {
            this.toastrService.error('Error Sending Activation Link', 'Please try again later');
          });

        }, (err) => {
          this.toastrService.error('Invalid Details', 'User Details are invalid');
        });
      });
    } else {
      this.toastrService.warning('Invalid Details', 'Please Provide User Details');
    }
  }

  goToSignUp() {
    this.router.navigate(["/signup"]);
  }

  togglePasswordVisibility(field: string) {
    if (field === 'password') {
      this.hidePassword = !this.hidePassword;
    } else if (field === 'confirm') {
      this.hideConfirmPassword = !this.hideConfirmPassword;
    }
  }
}
